// import { legacy_createStore, applyMiddleware } from 'redux'
// import thunk from 'redux-thunk'
// import { composeWithDevTools } from 'redux-devtools-extension'
// import reducers from './reducers'
import { configureStore } from '@reduxjs/toolkit'
import menu from './modules/menu'
import user from './modules/user'
import video from './modules/video'
import product from './modules/product'
import search from './modules/search'
import cart from './modules/cart'

// const store = createStore(reducers, composeWithDevTools(applyMiddleware(thunk)))
const store = configureStore({
  reducer: {
    menu,
    user,
    video,
    product,
    search,
    cart
  },
  middleware:(getDefaultMiddleware)=>[...getDefaultMiddleware({serializableCheck:false})]
})

export default store